import { render, staticRenderFns } from "./Smart.vue?vue&type=template&id=986aa1d4&scoped=true"
import script from "./Smart.vue?vue&type=script&lang=js"
export * from "./Smart.vue?vue&type=script&lang=js"
import style0 from "./Smart.vue?vue&type=style&index=0&id=986aa1d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986aa1d4",
  null
  
)

export default component.exports